import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface CtaButtonProps {
  text?: string;
  subtext?: string;
  href?: string;
  onClick?: () => void;
  className?: string;
}
export function CtaButton({
  text = 'SÍ, QUIERO ELIMINAR MIS DEUDAS',
  subtext = 'ACCESO INMEDIATO POR $6,37 usd',
  href,
  onClick,
  className = ''
}: CtaButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(201, 168, 76, 0.4)', '0px 0px 20px 5px rgba(201, 168, 76, 0.2)', '0px 0px 0px 0px rgba(201, 168, 76, 0.4)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} onClick={() => {
    if (href) {
      trackAddToCart();
      window.open(href, '_blank');
    } else {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.();
  }} className={`group relative w-full max-w-xl mx-auto flex flex-col items-center justify-center bg-gradient-to-b from-gold-400 to-gold-600 text-navy-900 rounded-xl px-6 py-4 font-bold shadow-lg hover:from-gold-300 hover:to-gold-500 transition-all duration-300 cursor-pointer ${className}`} data-id="element-40">
      <div className="flex items-center gap-2 text-lg md:text-xl lg:text-2xl text-center uppercase tracking-wide" data-id="element-41">
        <span data-id="element-42">{text}</span>
      </div>
    </motion.button>;
}